export function enumToArray<T extends Record<string, string | number>>(enumeration: T): T[keyof T][] {
    return Object.keys(enumeration)
        .filter((key) => isNaN(Number(key)))
        .map((key) => enumeration[key])
        .filter((val) => typeof val === "number" || typeof val === "string") as T[keyof T][];
}
